/**
 * App-level configuration. Keep exports typed so consumers get autocomplete
 * and the values flow through to the Klaviyo event + Shopify cart attributes
 * without drift.
 */

/** Bumped when scoring logic changes in a way downstream analytics needs to segment by. */
export const QUIZ_VERSION = 'v3' as const

/** NP Shopify storefront base for building product URLs. */
export const SHOPIFY_BASE_URL = 'https://nobodysprincess.com.au' as const

/** Privacy policy URL — shown under the email capture as a disclosure. */
export const PRIVACY_POLICY_URL = 'https://nobodysprincess.com.au/policies/privacy-policy' as const

/** Submission endpoint. Phase 4 builds the Netlify function at this path. */
export const SUBMIT_ENDPOINT = '/.netlify/functions/submit' as const

/**
 * sessionStorage key for quiz progress. Allows a refresh partway through the
 * quiz to resume without losing answers. Bumped on QUIZ_VERSION change.
 */
export const SESSION_STORAGE_KEY = `np-fitquiz:${QUIZ_VERSION}`
